// extracted by mini-css-extract-plugin
export default {"modalContent":"AddStoreModal_modalContent__2u1ra"};